import moment from "moment";
import SalesOrderService from "@/services/salesService";
import InvoiceService from "@/services/invoiceService";
import CreditService from "@/services/creditService";
export const InvoiceStore = {
    namespaced: true,
    state: {
        tabs: {
            order_to_invoice: {
                purchase_order_id: null,
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "order_date",
                sortOrder: -1,
                first:0,
                enableExpander:false,
            },
            invoices: {
                purchase_order_id: null,
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "invoice_date",
                sortOrder: -1,
                first:0,
                enableExpander:false,
            },
            credit: {
                purchase_order_id: null,
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "credit_date",
                sortOrder: -1,
                first:0,
                enableExpander:false,
            },
            warranty: {
                purchase_order_id: null,
                tableData: [],
                totalRecords: 0,
                rowsPerPage: 20,
                currentPage: 1,
                sortField: "invoice_date",
                sortOrder: -1,
                first:0,
                enableExpander:false,
                expandedRows: [],
            },
        },
        currentTab: "order_to_invoice",
        searchText: "",
        fromDate: null,
        toDate: null,
        isLoading: false,
        lastSelectedRowId: '',
    },
    mutations: {
        SET_TABLE_DATA(state, {tab, data}) {
            state.tabs[tab].tableData = data.data;
            state.tabs[tab].totalRecords = data.count;
        },
        UPDATE_CURRENT_PAGE(state, {tab, page}) {
            state.tabs[tab].currentPage = page;
        },
        UPDATE_ROWS_PER_PAGE(state, {tab, rows}) {
            state.tabs[tab].rowsPerPage = rows;
        },
        UPDATE_SORT_OPTIONS(state, {tab, field, order}) {
            state.tabs[tab].sortField = field;
            state.tabs[tab].sortOrder = order;
        },
        RESET_FIRST_VALUE(state, { tab }) {
            const currentPage = state.tabs[tab].currentPage;
            const rowsPerPage = state.tabs[tab].rowsPerPage;
            state.tabs[tab].first = currentPage > 0 ? (currentPage - 1) * rowsPerPage : 0;
        },
        RESET_CURRENT_PAGE(state, { tab, page = 0 }) {
            state.tabs[tab].currentPage = page;
        },
        UPDATE_SEARCH_TEXT(state, searchText) {
            state.searchText = searchText;
        },
        UPDATE_CURRENT_TAB(state, currentTab) {
            state.currentTab = currentTab;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        UPDATE_FROM_DATE(state, fromDate) {
            state.fromDate = fromDate;
        },
        UPDATE_TO_DATE(state, toDate) {
            state.toDate = toDate;
        },
        SET_LAST_SELECTED_ROW(state, lastSelectedRowId) {
            state.lastSelectedRowId = lastSelectedRowId;
        },
        SET_EXPANDED_ROWS(state, { tab, rows }) {
            state.tabs[tab].expandedRows = rows;
        },
    },
    actions: {
        async fetchTableData({commit, state,dispatch}) {
            debugger;
            commit("SET_LOADING", true);
            const currentTabState = state.tabs[state.currentTab];

            let params = buildParams(currentTabState, state);
            const apiEndpoint = getApiEndpoint(state.currentTab);
            const queryString = buildQueryString(params);

            try {
                let data = await apiEndpoint(`?${queryString}`);
                commit("SET_TABLE_DATA", {tab: state.currentTab, data});

                if (state.currentTab === "dispatch_notes") {

                    const uniqueSalesOrderIds = Array.from(new Set(state.tabs.dispatch_notes.expandedRows.map(row => row.sales_order_id)));

                    const filteredData = data.data.filter(item => uniqueSalesOrderIds.includes(item.sales_order_id));

                    commit("SET_EXPANDED_ROWS", { tab: "dispatch_notes", rows: filteredData });
                }

            } catch (error) {
                commit("SET_TABLE_DATA", {tab: state.currentTab, data: []});
                console.error("Error fetching data:", error);
            } finally {
                commit("SET_LOADING", false);
                dispatch("resetFirstValue");
            }
        },
        updateTableSettings({commit, dispatch, state}, {rows, page}) {
            commit("UPDATE_ROWS_PER_PAGE", {tab: state.currentTab, rows});
            commit("UPDATE_CURRENT_PAGE", {tab: state.currentTab, page: page + 1});
            dispatch("fetchTableData");
        },
        updateSortOptions({commit, dispatch, state}, {field, order}) {
            commit("UPDATE_SORT_OPTIONS", {tab: state.currentTab, field, order});
            dispatch("fetchTableData");
        },
        updateSearchCriteria({commit}, {searchText, selectedEngineer, fromDate, toDate}) {
            commit("UPDATE_SEARCH_TEXT", searchText);
            commit("UPDATE_FROM_DATE", fromDate);
            commit("UPDATE_TO_DATE", toDate);
            dispatch("fetchTableData");
        },
        updateTab({commit, dispatch}, currentTab) {
            commit("UPDATE_CURRENT_TAB", currentTab);
            dispatch("fetchTableData");
        },
        resetFirstValue({ commit, state }) {
            commit("RESET_FIRST_VALUE", { tab: state.currentTab });
        },
        resetCurrentPage({ commit, state }, page = 0) {
            commit("RESET_CURRENT_PAGE", { tab: state.currentTab, page });
        },
        updateExpandedRows({ commit, state }, rows) {
            commit("SET_EXPANDED_ROWS", { tab: state.currentTab, rows });
        },
    },
};

function buildQueryString(params) {
    return Object.entries(params)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
}

function buildParams(currentTabState, state) {
    debugger;
    let params = {
        page: currentTabState.currentPage,
        limit: currentTabState.rowsPerPage,
        orderBy: currentTabState.sortField,
        order: currentTabState.sortOrder,
        tab: state.currentTab,
    };

    if (state.searchText) {
        params.searchTerm = state.searchText;
    }

    if (state.fromDate) {
        params.fromDate = moment(state.fromDate).format('DD/MM/YYYY');
    }

    if (state.toDate) {
        params.toDate = moment(state.toDate).format('DD/MM/YYYY');
    }

    // Add status based on the current tab
    switch (state.currentTab) {
        case 'order_to_invoice':
            params.status = ['completed'];
            break;
        case 'invoices':
            params.status = ["pending", "paid", "overdue", "under query", "pro-forma", "cancelled"];
            params.type = [
                "SPARE PARTS",
                "QUOTATION",
                "INT JOBSHEET",
                "EXT JOBSHEET",
                "EQUIPMENT",
                "FOC"
            ];
            break;
        case 'credit':
            params.status = [];
            break;
        case 'warranty':
            params.status = [];
            params.type = [
                "WARRANTY"
            ];
            break;
        // No need to add a status filter for 'all_purchases'
        default:
            break;
    }

    return params;
}

function getApiEndpoint(currentTab) {
debugger;
    if (currentTab === "invoices") {
        return InvoiceService.searchAllInvoices; // Use the Invoice service for the "Invoices" tab
    }
    if (currentTab === "credit") {
        return CreditService.searchAllCredits; // Use the Credit service for the "Credits" tab
    }
    if (currentTab === "warranty") {
        return InvoiceService.searchAllInvoices; // Use the Invoice service for the "Invoices" tab
    }
    return SalesOrderService.searchAllSalesOrders; // Default endpoint
}

